import { render, staticRenderFns } from "./CmgPersonIconWithBadge.vue?vue&type=template&id=1e5d3972&scoped=true&lang=pug&"
import script from "./cmg-person-icon-with-badge.ts?vue&type=script&lang=ts&"
export * from "./cmg-person-icon-with-badge.ts?vue&type=script&lang=ts&"
import style0 from "./CmgPersonIconWithBadge.vue?vue&type=style&index=0&id=1e5d3972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5d3972",
  null
  
)

export default component.exports